var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Select',{attrs:{"idKey":"id","textKey":"name","isLoading":_vm.loading,"entityName":_vm.$tc('application.title'),"items":_vm.items,"autoFocus":true},model:{value:(_vm.item),callback:function ($$v) {_vm.item=$$v},expression:"item"}})}
var staticRenderFns = []

export { render, staticRenderFns }